import { useState, useEffect } from "react";
import "./Toggle.css";

function Toggle({value, onToggle}) {

    const [isOn, setIsOn] = useState(value);

    const handleToggle = () => {
        const newValue = !isOn;
        setIsOn(newValue);
        onToggle(newValue);
    };

    useEffect(() => {
        setIsOn(value);
    }, [value]);

    return (
        <div 
            className="toggle"
        >
            <div 
                className={`toggle-toggle ${isOn ? 'toggle-toggle-on' : 'toggle-toggle-off'}`}
                onClick={handleToggle}
            >
                <div 
                    className={`toggle-toggle-button ${isOn ? 'toggle-toggle-button-on' : 'toggle-toggle-button-off'}`}
                >
                </div>
            </div>
        </div>
    );
}

export default Toggle;